window.addEventListener('load', function () {
    /* expand Contact on load */
    var contact = $(".contact");
    setTimeout(function () {
        if (contact.hasClass("closed")) {
            contact.removeClass("closed");
        }
        if ($("div.contact")) {
            /* get contact elements (left & right) */
            let l = $(".contact > .d-flex > .col-6")[0];
            let r = $(".contact > .d-flex > .col-6")[1];
            /* stop if no l & r are given / not found */
            if (l && r) {
                l.classList.add("left");
                r.classList.add("right");
                /* get sizes for comparison */
                var cHL = l.clientHeight,
                    cHR = r.clientHeight;
                /* get document width */
                var width = $(document).width();
                /* set left element height if width ok */
                if (cHR > cHL && width > 768) {
                    l.style.height = cHR + "px";
                }
            }
        }
    }, 100);

    try {
        if(document.querySelector('.loadmore')) {
            let loadmore = document.querySelector('.loadmore');
            if (document.querySelectorAll('.news-list-view .article.hidden').length > 0) loadmore.classList.remove('hidden');

            loadmore.addEventListener('click', function (e) {
                e.preventDefault();
                document.querySelectorAll('.news-list-view .article.hidden').forEach((event, iterator) => {
                    if (iterator < 8) event.classList.remove('hidden');
                });
                if (document.querySelectorAll('.news-list-view .article.hidden').length == 0) loadmore.classList.add('hidden');
            });
            if (document.querySelectorAll('.news-list-view .article.hidden').length == 0) loadmore.classList.add('hidden');
        }
    } catch (error) {
        console.error(error);
    }
});
